import { render, staticRenderFns } from "./reviewItem.vue?vue&type=template&id=1d1fe7b8"
import script from "./reviewItem.vue?vue&type=script&lang=js"
export * from "./reviewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d1fe7b8')) {
      api.createRecord('1d1fe7b8', component.options)
    } else {
      api.reload('1d1fe7b8', component.options)
    }
    module.hot.accept("./reviewItem.vue?vue&type=template&id=1d1fe7b8", function () {
      api.rerender('1d1fe7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/reviewItem.vue"
export default component.exports